import dayjs from 'dayjs';
import type { TFunction } from 'i18next';

import type { OpenMeteoHourlyBlock } from '@/features/dashboard/types/openMeteo.types';
import type { WeatherForecastListItem } from '@/features/dashboard/types/weatherForecast.types';

import { describeWmoWeatherCode, wmoCodeToUiIcon } from './wmoWeather';

/**
 * Converts Open-Meteo hourly block to a generic UI forecast list.
 */
export function hourlyOpenMeteoToUiForecast(
  hourly: OpenMeteoHourlyBlock,
  t: TFunction,
): WeatherForecastListItem[] {
  const { time, temperature_2m, weather_code } = hourly;
  const popArr = hourly.precipitation_probability ?? [];
  const windArr = hourly.wind_speed_10m ?? [];
  if (!time?.length) return [];

  return time.map((timeStr, i) => {
    const wCode = weather_code[i];
    const codeNum = wCode ?? 0;
    const desc = describeWmoWeatherCode(codeNum, t);
    const temp = temperature_2m[i];
    const popPct = popArr[i];
    const wind = windArr[i];

    return {
      dt: dayjs(timeStr).unix(),
      main: { temp: temp ?? 0 },
      weather: [
        {
          id: codeNum,
          main: '',
          description: desc,
          icon: wmoCodeToUiIcon(codeNum),
        },
      ],
      wind: wind != null ? { speed: wind, deg: 0 } : undefined,
      pop: popPct != null ? Math.min(100, Math.max(0, popPct)) / 100 : undefined,
    };
  });
}
